// Modules
import { createSelector } from 'reselect';

// Types
import { Store } from '../types/store';
import { FacetState } from '../types/facets';

export const allFacets = (state: Store): FacetState => state.facet.data;

export const getFacets = (facetKey: string) =>
	createSelector(allFacets, (facets:any) => {
		const items: any[] = [];
		Object.keys(facets).map((facet: string): void => {
			if (facet.includes(facetKey)) {
				items.push(facets[facet]);
			}
		});
		
		return items;
	});
